export const kQuestionTileType = "Question";
